// extracted by mini-css-extract-plugin
export var callCard = "_oz-0";
export var callMessageButton = "_oz-1";
export var helpIcon = "_oz-3";
export var helpIconContainer = "_oz-4";
export var verticalDivider = "_oz-2";